import { useState } from 'react'
import { ReactSVG } from 'react-svg'
import clsx from 'clsx'

interface Props {
	id?: string
	name?: string
	className?: string
	placeholder?: string
	autoComplete?: string
	onChange?: any
	onBlur?: any
	value?: any
	/** What the toggle shows or hides, e.g. "new password" — used to name it "Show new password". */
	toggleLabel?: string
	'aria-invalid'?: boolean
	'aria-describedby'?: string
}

export function PasswordMaskField({ value, onChange, onBlur, toggleLabel, ...props }: Readonly<Props>) {
	const [type, setType] = useState('password')
	const hidden = type === 'password'

	const toggleType = () => {
		setType(hidden ? 'text' : 'password')
	}
	return (
		<div className="relative">
			<input type={type} value={value} onChange={onChange} onBlur={onBlur} {...props} />
			<button
				type="button"
				className="absolute top-1/2 right-1.5 -translate-y-1/2 rounded p-2.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-surface"
				onClick={toggleType}
				aria-label={`${hidden ? 'Show' : 'Hide'} ${toggleLabel ?? 'password'}`}
			>
				<span aria-hidden="true">
					<ReactSVG className={clsx({ hidden })} src="/images/auth/icon-eye-slash.svg" />
					<ReactSVG className={clsx({ hidden: !hidden })} src="/images/auth/icon-eye.svg" />
				</span>
			</button>
		</div>
	)
}
